import React from "react"
import { ItemCarrinho } from "../../../CatalogoPage";
import BoxComponent from "../../../../../../components/Box/BoxComponent";
import { Stack } from "@mui/material";
import TypographyComponent from "../../../../../../components/Typography/ThypographyComponent";
import { formatNumberToDinheiro } from "../../../../../../utils/dinheiro";
import ItemCarrinhoCardComponent from "../ItemCarrinhoCardComponent";
import TextFieldComponent from "../../../../../../components/TextField/TextFieldComponent";

interface EtapaCarrinhoProps {
    itens: ItemCarrinho[];
    onChangeItens: (itens: any) => void;
    calculoTotalItens: number;
    observacaoGeral: string;
    onChangeObservacaoGeral: (observacao: string) => void;
}

const EtapaCarrinhoComponent = (props: EtapaCarrinhoProps) => {
    // Funções de manipulação
    const handleUpdateQtd = (id: string, delta: number) => {
        props.onChangeItens((prev: any[]) => prev.map(i =>
            i.item.id === id ? { ...i, qtd: Math.max(1, i.qtd + delta) } : i
        ));
    };

    const handleRemove = (id: string) => {
        props.onChangeItens((prev: any[]) => prev.filter(i => i.item.id !== id));
    };

    const handleObs = (id: string, obs: string) => {
        props.onChangeItens((prev: any[]) => prev.map(i =>
            i.item.id === id ? { ...i, observacao: obs } : i
        ));
    };

    const renderItensCarrinho = () => {
        if (props.itens === null) return <></>

        if (props.itens.length === 0) {
            return <TypographyComponent>
                Carrinho vazio
            </TypographyComponent>
        }       

        return <>
            {
                props.itens.map((item, index) => (
                    <ItemCarrinhoCardComponent
                        key={`item-${index}`}
                        item={item}
                        onIncrement={(id) => handleUpdateQtd(id, 1)}
                        onDecrement={(id) => handleUpdateQtd(id, -1)}
                        onRemove={handleRemove}
                        onObsChange={handleObs}
                    />
                ))
            }
        </>
    }

    const renderObservacao = () => {
        if (props.itens.length === 0) return <></>

        return <TextFieldComponent
            id="observacao"
            placeholder="Ex: Sem cebola, extra queijo..."
            label="Observações"
            value={props.observacaoGeral}
            onChange={(e) => props.onChangeObservacaoGeral(e.target.value)}
            fullWidth
            //sx={{minHeight: 40, overflow: "auto" }}
            multiline
            maxRows={4}
        />
    }

    return <>
        <BoxComponent
            component="div"
            sx={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                flexGrow: 1,
                minHeight: 0, // Permite o scroll interno funcionar na altura correta
                gap: 1
            }}
        >
            <BoxComponent component="div" sx={{
                display: "flex",
                flexDirection: "column",
                p: 2,
                overflowY: 'auto',    // O scroll vertical fica EXCLUSIVO aqui
                overflowX: 'hidden',  // Evita overflow horizontal de cartões malucos
                flexGrow: 1,
                width: '100%',
                boxSizing: 'border-box', // Garante que o p: 2 não mude a largura de 100%
                bgcolor: '#fafafa',
                gap: 0,
            }}>
                {/* LISTA DE ITENS */}
                <BoxComponent component="div"
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                        maxHeight: "80%",
                        overflow: "auto"
                    }}
                >
                    {renderItensCarrinho()}
                </BoxComponent>

                {/* LISTA DE OBSERVAÇÕES */}
                <BoxComponent component="div"
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        width: "100%"
                    }}
                >
                    {renderObservacao()}
                </BoxComponent>
            </BoxComponent>

            {/* CONTAINER DO TOTAL (Fica fixo logo acima do botão de envio) */}
            <BoxComponent component="div" sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                px: 2,
                py: 1.5,
                width: '100%',
                boxSizing: 'border-box',
                bgcolor: '#fafafa',
                borderTop: '1px solid #E5E7EB' // Um detalhe visual para separar os itens do total
            }}>
                <TypographyComponent variant="body2"
                    sx={{
                        fontFamily: '"Font 7", sans-serif',
                        fontWeight: 600,
                        fontSize: '18px',
                        lineHeight: '28px',
                        color: '#101828',
                    }}
                >
                    Total:
                </TypographyComponent>
                <TypographyComponent variant="body2" sx={{
                    fontFamily: '"Font 7", sans-serif',
                    fontWeight: 700,
                    fontSize: '20px',
                    lineHeight: '32px',
                    color: '#E7000B',
                }}>
                    {formatNumberToDinheiro(props.calculoTotalItens)}
                </TypographyComponent>
            </BoxComponent>
        </BoxComponent>
    </>
}

export default EtapaCarrinhoComponent;